<template>
    <div class="drawer flex-column d-flex align-items-center blue-background" v-bind:class="{ open: isOpen }">
        <div style="height: 80px;"></div>
        <br />
        <router-link class="navitem" to="/about" @click.native="close();">{{ $t('about_us_title') }}</router-link>
        <b-dropdown id="dropdown-1">
            <template #button-content>
                <div class="d-flex ddn">
                    <p style="margin:0;">{{ $t('programs') }}</p>
                </div>
            </template>
            <b-dropdown-item to="/highschool" @click.native="close();">{{ $t('higher_edu_title') }}</b-dropdown-item>
            <b-dropdown-item to="/middleschool" @click.native="close();">{{ $t('ms_title') }}</b-dropdown-item>
            <b-dropdown-item to="/languagecourses" @click.native="close();">{{ $t('lc_title') }}</b-dropdown-item>
            <b-dropdown-item to="/scholarship" @click.native="close();">{{ $t('scholar_title') }}</b-dropdown-item>
        </b-dropdown>
        <router-link class="navitem" to="/countries" @click.native="close();">{{ $t('abroad_edu') }} </router-link>
        <router-link class="navitem" to="/articles" @click.native="close();">{{ $t('articles') }}</router-link>
        <router-link class="navitem" to="/contacts" @click.native="close();">{{ $t('contacts') }}</router-link>
        <br />
        <LanguageSelectComponent></LanguageSelectComponent>

        <div class="d-flex d-lg-none social-buttons-m justify-content-between py-4 px-5">
            <a class="m-5" href="https://www.linkedin.com/company/ib-academy-az/" target="_blank">
                <img src="@/assets/linkedin.svg" />
            </a>
            <a class="m-5" href="https://www.facebook.com/ib.academy.aze" target="_blank">
                <img src="@/assets/facebook.svg" />
            </a>
            <a class="m-5" href="https://www.instagram.com/ib.academy.az/" target="_blank">
                <img src="@/assets/instagram.svg" />
            </a>
            <a class="m-5" href="https://www.tiktok.com/@ib.academy.az" target="_blank">
                <img src="@/assets/tiktok.svg" />
            </a>
            <a class="m-5" href="https://www.threads.net/@ib.academy.az" target="_blank">
                <img src="@/assets/threads.svg" />
            </a>
        </div>
        <div class="arrow-up mx-auto blue-background" @click="close();">
            <img src="@/assets/arrow_up.svg" />
        </div>
    </div>
</template>
<script>
import LanguageSelectComponent from './LanguageSelectComponent.vue';
export default {
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        open() {
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        }
    },
    components: { LanguageSelectComponent }
}
</script>
<style lang="css">
.drawer {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2 !important;
    top: -120%;
    transition: all .4s ease-out;
    border-radius: 0 0 30px 30px;
}

.open {
    top: 0px;
}

.arrow-up {
    width: 50px;
    height: 50px;

    transform: translateY(60%);
    border-radius: 40px;
}

.arrow-up img {
    height: 50px;
    width: 22px;
    object-fit: contain;
}
</style>